/* PRIVATE EVENTS — a hover-ticker of event photos; click any to view it full size */
(function () {
  'use strict';

  var track = document.getElementById('tickerTrack');
  var lightbox = document.getElementById('lightbox');
  if (!track || !lightbox) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // the real photos, in order — this is what the lightbox pages through
  var originals = [].slice.call(track.querySelectorAll('.ticker-card'));
  var photos = originals.map(function (btn) {
    var img = btn.querySelector('img');
    return { full: btn.getAttribute('data-full'), alt: img.alt };
  });

  /* ---- seamless loop: clone the strip once so translateX(-50%) wraps cleanly ---- */
  if (!reduced) {
    originals.forEach(function (btn) {
      var clone = btn.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      track.appendChild(clone);
    });

    // hold a constant scroll speed (~70px/s) regardless of how wide the strip is
    var setSpeed = function () {
      var setWidth = track.scrollWidth / 2;
      if (setWidth > 0) track.style.setProperty('--ticker-dur', (setWidth / 70).toFixed(1) + 's');
    };
    setSpeed();
    window.addEventListener('load', setSpeed);
    window.addEventListener('resize', setSpeed, { passive: true });

    /* faint moving photo-wall behind the section — the same photos, three drifting rows */
    var bg = document.querySelector('.events-bg');
    if (bg) {
      var thumbs = originals.map(function (b) { return b.querySelector('img').getAttribute('src'); });
      for (var r = 0; r < 3; r++) {
        var row = document.createElement('div');
        row.className = 'events-bg-row';
        // rotate each row's order so the three strips don't line up
        var seq = thumbs.slice(r * 3).concat(thumbs.slice(0, r * 3));
        seq.concat(seq).forEach(function (src) {   // doubled so the loop wraps seamlessly
          var im = document.createElement('img');
          im.src = src; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
          row.appendChild(im);
        });
        bg.appendChild(row);
      }
    }
  }

  /* ---- lightbox ---- */
  var lbImg = document.getElementById('lbImg');
  var lbClose = document.getElementById('lbClose');
  var lbPrev = document.getElementById('lbPrev');
  var lbNext = document.getElementById('lbNext');
  var current = 0;
  var lastFocused = null;

  function show(i) {
    current = (i + photos.length) % photos.length;
    lbImg.src = photos[current].full;
    lbImg.alt = photos[current].alt;
  }
  function open(i) {
    lastFocused = document.activeElement;
    show(i);
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    lbClose.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    lbImg.src = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocused) lastFocused.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(current + 1);
    else if (e.key === 'ArrowLeft') show(current - 1);
  }

  // one delegated handler covers originals and clones alike
  track.addEventListener('click', function (e) {
    var card = e.target.closest('.ticker-card');
    if (card) open(Number(card.getAttribute('data-idx')) || 0);
  });
  lbClose.addEventListener('click', close);
  lbPrev.addEventListener('click', function () { show(current - 1); });
  lbNext.addEventListener('click', function () { show(current + 1); });
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
})();
